import { isConditionSourceCustomFieldType } from "@repo/shared";
import { useParams } from "react-router";

import { FEATURE_FLAGS } from "@/lib/feature-flags";
import { useAllCustomFields } from "@/lib/hooks/use-clients";
import { useFeatureFlag } from "@/lib/hooks/use-feature-flags";
import { PageEditor } from "./page-editor";

export default function FlowPageEditorPage() {
  const params = useParams();
  const flowId = params.id as string;
  const pageId = params.pageId as string;

  const { customFields, isLoading: fieldsLoading } = useAllCustomFields();
  const { enabled: hasXRayAccess, isLoading: flagLoading } = useFeatureFlag(
    FEATURE_FLAGS.MORNINGSTAR_XRAY,
  );

  if (fieldsLoading || flagLoading) return null;

  // Every type the conditional-visibility picker accepts as a rule source
  // (QL-254: all but "user"). Standard pseudo-fields are excluded — they are not custom_field rows and
  // their sources exist as dedicated sentinels (Client Country, Client Type, …).
  const filteredCustomFields = customFields
    .filter((f: any) => !f.isStandard && isConditionSourceCustomFieldType(f.type))
    .map((f: any) => ({
      id: f.id,
      name: f.name,
      type: f.type,
      options: f.options,
      isActive: f.isActive,
    }));

  return (
    <PageEditor
      flowId={flowId}
      pageId={pageId}
      clientCustomFields={filteredCustomFields}
      hasXRayAccess={hasXRayAccess}
    />
  );
}
